import { render, staticRenderFns } from "./Talent.vue?vue&type=template&id=1335c3c6&scoped=true"
import script from "./Talent.vue?vue&type=script&lang=js"
export * from "./Talent.vue?vue&type=script&lang=js"
import style0 from "./Talent.vue?vue&type=style&index=0&id=1335c3c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1335c3c6",
  null
  
)

export default component.exports